export enum ProviderTypeEnum {
    WALLET = "WALLET",
    BANK = "BANK",
    OVO = "OVO",
    PAYFAST_CHECKOUT = "PAYFAST_CHECKOUT",
    ONE_BILL = "ONE_BILL",
    BILL = "BILL"
}
